
import { isEmpty, isNil } from 'lodash';

export default {

  props: {
    label: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      disabledByConfig: false,
    };
  },

  computed: {
    disabledCombined: function () {
      return this.disabled || this.disabledByConfig;
    },
  },

  created: function () {
    try {
      this.$attrs = this.$attrs || {};
      const path = this.getHmComponentPath();
      this.$attrs['hm-path'] = path;
      this.disabledByConfig = this.$root.hmDisabledFields.includes(path);
      // this.disabledByLogic = !this.$root.hasRole('ROLE_SYSADMIN') && true;
    } catch (ignore) { /* ignore */ }
  },

  methods: {
    getHmComponentPath() {
      return `${this.getTree(this)
        .filter(it => !isEmpty(it) && it.startsWith('Page'))
        // eslint-disable-next-line no-useless-escape
        .join('.')}.action.${this.id || this.$attrs.id || this.name || (`${this.label || ''}-gen`).replaceAll(/[^a-zA-Z0-9äöüßÄÖÜ\-]/gim, '')}`;
    },
    getTree: function (self) {
      const tree = [];
      tree.push(self.$options.name);
      if (!isNil(self.$parent) && self.$parent !== self && self.$parent !== self.$root) {
        this.getTree(self.$parent).forEach(it => tree.push(it));
      }
      return tree;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/HmFloatingButtonMixin.js